const Premise = {

    // FIELDS
    "name": "Name",
    "phone": "Phone",
    "city": "City / District",
    "pincode": "Pincode",
    "address": "Address",
    "landmark": "Landmark",
    "zones": "No. of Zones",

    "zone": "Zone",
    "level": "Level",
    "unit": "Unit",

    "module": "Module",
    "configuration": "Configuration",
    "config_accounts": "Accounts & Invoices",
    "config_mfa": "MFA",
    "config_defaulters": "Defaulters List",
    "config_email": "Email",
    "config_sms": "SMS",
    "config_payment_gateway": "Payment Gateway",
    "select_all": "Select All",
    "search": "Search",

    // PAGE HEADER
    "premise": "Premise",
    "premise_hierarchy": "Premise Hierarchy",

    // ERROR
    "error_name": "Enter Name",
    "error_phone": "Enter Phone",
    "error_invalid_phone": "Invalid Phone",
    "error_city": "Select City",
    "error_pincode": "Enter Pincode",
    "error_invalid_pincode": "Invalid Pincode",
    "error_address": "Enter Address",
    "error_landmark": "Enter Landmark",
    "error_zones": "Enter Zones",
    "error_invalid_zones": "Invalid Zones",
    "error_module": "Please check at least one module",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_phone": "PHONE",
    "table_zones": "ZONES",
    "table_city": "CITY",
    "table_address": "ADDRESS",
    "table_created_by": "CREATED BY",

    "table_premise": "PREMISE",
    "table_zone": "ZONE",
    "table_level": "LEVEL",
    "table_unit": "UNIT",
    "table_area": "AREA (SQ. FT.)",

}

export default Premise;